import { render, staticRenderFns } from "./Factoid.vue?vue&type=template&id=575a1d32"
import script from "./Factoid.vue?vue&type=script&lang=js"
export * from "./Factoid.vue?vue&type=script&lang=js"
import style0 from "./Factoid.vue?vue&type=style&index=0&id=575a1d32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports